import { render, staticRenderFns } from "./EnvironmentBanner.vue?vue&type=template&id=d91f9824&scoped=true&"
var script = {}
import style0 from "./EnvironmentBanner.vue?vue&type=style&index=0&id=d91f9824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91f9824",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
